<template>
  <qc-container title="用户详情" show-return show-divider>
    <el-descriptions v-if="detail" :column="4" border>
      <el-descriptions-item label="用户" >
        <user-box :detail="detail"></user-box>
      </el-descriptions-item>
      <el-descriptions-item label="手机号码">
        <div style="min-width: 100px">{{detail.phone}}</div>
      </el-descriptions-item>
      <el-descriptions-item label="地区">
        <div style="min-width: 100px">
          {{(detail.province||"")+(detail.city||"")}}
        </div>
      </el-descriptions-item>
    </el-descriptions>
  </qc-container>

  <on-line-order v-if="detail&&detail.userId" :user-id="detail.userId"></on-line-order>

</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import UserBox from "@view/components/user-box.vue";
import OnLineOrder from "@org/order/list.vue";

export default {
  name: "detail",
  components: {OnLineOrder, UserBox, QcContainer},
  data() {
    return {
      detail:null,
      activeIndex:0,
    }
  },
  mixins: [tableBase],
  methods: {
    changeTab(index){
      this.activeIndex = index;
    }
  },
  mounted() {
    this.simplePost("/api/mgr/user/expand/getDetail",{id:this.$route.query.id},(res)=>{
      this.detail = res.data;
    });
  }
}
</script>


<style lang="less" scoped>
</style>
